import type {} from '@angular/localize/init';

export function appCountryBlockedRouteI18n(): string {
  return 'unavailable-page';
}
